module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": _vm.crowdfunding ? 'crowdtabs' : 'raistabs',
      "role": "tablist"
    }
  }, [_c('li', [(_vm.crowdfunding) ? _c('a', {
    staticClass: "first"
  }, [_vm._v("CROWDFUNDING:")]) : _c('a', {
    staticClass: "first"
  }, [_vm._v("FUNDRAISING:")])]), _vm._v(" "), _vm._l((_vm.projects), function(value, key) {
    return (value[0]) ? _c('li', {
      class: {
        'active': _vm.activeTab() === key
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      attrs: {
        "href": ("#" + key),
        "aria-controls": "rais-recommended",
        "role": "tab",
        "data-toggle": "tab"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(("main." + key))) + "\n      ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', [(_vm.crowdfunding) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'crowdfunding'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("main.seeAll")))]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'fundraising'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("main.seeAll")))])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, _vm._l((_vm.projects), function(value, key) {
    return _c('div', {
      class: ['tab-pane fade', {
        'in active': _vm.activeTab('fundraising') === key
      }],
      attrs: {
        "id": ("" + key),
        "role": "tabpanel"
      }
    }, [(_vm.crowdfunding) ? _c('div', {
      staticClass: "row"
    }, _vm._l((value), function(project) {
      return _c('crowdfunding-tile', {
        key: project.id,
        attrs: {
          "project": project,
          "size": 'col-md-6'
        }
      })
    }), 1) : _c('div', {
      staticClass: "row"
    }, _vm._l((value), function(project) {
      return _c('fundraising-tile', {
        key: project.id,
        attrs: {
          "project": project,
          "size": 'col-md-4'
        }
      })
    }), 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-814d0e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Tabs.vue
// module id = 825
// module chunks = 1